import { getRequest, postRequest, patchRequest, deleteRequest } from '../../services/apiService';
import { getPropertyVerificationsAction, getPropertyVerificationsCountAction, getPropertyVerificationAction, getVerificationTag } from '../reducers/PropertyVerificationReducer';

const route_path = 'propertyverification'

export const getAllPropertyVerifications = ({ page, limit, search, status, columnName }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/list`, { page, limit, search, status, columnName });
    dispatch(getPropertyVerificationsAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getAllPropertyVerificationCount = ({ page, limit, search, status }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/count`, { page, limit, search, status });
    dispatch(getPropertyVerificationsCountAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getPropertyVerificationsById = (propertyVerificationsId) => async (dispatch) => {
  try {
    
    const response = await getRequest(`${route_path}/${propertyVerificationsId}`);
    console.log("Property Verification Details:", response);
    dispatch(getPropertyVerificationAction(response));
  } catch (error) {
    console.error(`Error fetching propertyVerifications with ID ${propertyVerificationsId}:`, error);
    throw error;
  }
};

export const createPropertyVerifications = (propertyVerificationsData) => async (dispatch) => {
  try {
    const response = await postRequest(`${route_path}/add`, propertyVerificationsData);
  } catch (error) {
    console.error("Error creating propertyVerifications:", error);
    throw error;
  }
};

export const updatePropertyVerifications = (propertyVerificationsId, propertyVerificationsData) => async (dispatch) => {
  try {
    
    const response = await patchRequest(`${route_path}/edit/${propertyVerificationsId}`, propertyVerificationsData);
  } catch (error) {
    console.error(`Error updating propertyVerifications with ID ${propertyVerificationsId}:`, error);
    throw error;
  }
};

export const deletePropertyVerifications = (propertyVerificationsId) => async (dispatch) => {
  try {
    const response = await deleteRequest(`${route_path}/delete/${propertyVerificationsId}`);
  } catch (error) {
    console.error(`Error deleting propertyVerifications with ID ${propertyVerificationsId}:`, error);
    throw error;
  }
};

export const addPropertyVerificationsData = () => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/add/requireddata`)
  } catch (error) {
    console.error("Error while getting add propertyVerifications data:", error);
    throw error;
  }
}

export const getAllVerificationTag = ({ page, limit, search, status, columnName }) => async (dispatch) => {
  try {
    console.log(route_path)
    const response = await getRequest(`${route_path}/verifytag`, { page, limit, search, status, columnName });
    dispatch(getVerificationTag(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const updateVerificationTagStatus = (id, data) => async () => {
  try {

    const response = await patchRequest(
      `${route_path}/verifytag/${id}`,
      data
    );

    return response;

  } catch (error) {

    console.error("Error updating verification tag:", error);
    throw error;
  }
};